import CloneLeaguesSessionsIndex from './CloneLeaguesSessionsIndex'
import CloneLeaguesSessionsNewEdit from './CloneLeaguesSessionsNewEdit'

const Pages = {
  CloneLeaguesSessionsIndex,
  CloneLeaguesSessionsNewEdit,
}

export default Pages
